import RecoverEmailSent from './RecoverEmailSent'

export default RecoverEmailSent
